export default __webpack_public_path__ + "static/media/restart.e3343a75.mp3";